import { render, staticRenderFns } from "./ReviewFormPage.vue?vue&type=template&id=3ed28883"
import script from "./ReviewFormPage.vue?vue&type=script&lang=js"
export * from "./ReviewFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports